export default __webpack_public_path__ + "static/media/GEA Group.4543a3c1.png";